import React, { Fragment, useEffect, useState } from "react";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { TemplateColumn } from "Constants/TableColumns";
import { useDispatch } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { getTemplates } from "Stores/actions/properties/ShopAction";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import EditTemplate from "./Edit";
import DeleteTemplate from "./Delete";

export default function ListTemplate({ row, onEnter, reget }) {
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [tblData, setTblData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);

  const onChangeList = async (value) => {
    if (onEnter && value) await getList();
  };

  useEffect(() => {
    setColumns([
      ...TemplateColumn,
      {
        dataField: "edit",
        text: "",
        isDummyField: true,
        formatter: (ccell, crow) => (
          <EditTemplate
            idGroup={+row.Id}
            row={crow}
            onChangeList={onChangeList}
          />
        ),
        align: "right",
        classes: "normal",
        headerClasses: "action",
        editable: false,
      },
      {
        dataField: "delete",
        text: "",
        isDummyField: true,
        formatter: (ccell, crow) => (
          <DeleteTemplate
            idGroup={+row.Id}
            row={crow}
            onChangeList={onChangeList}
          />
        ),
        align: "right",
        classes: "normal",
        headerClasses: "action",
        editable: false,
      },
    ]);
  }, []);

  useEffect(() => {
    (async () => {
      if (onEnter) {
        await getList();
      }
    })();
  }, [onEnter]);

  useEffect(() => {
    (async () => {
      if (onEnter && reget) await getList();
    })();
  }, [reget]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      try {
        await getList(page, sizePerPage);
      } catch (err) {
        console.error("[catch error]", err);
      }
    }
  };

  const getList = async (Page = currentPage, Limit = sizePerPage) => {
    setLoading(true);
    try {
      const params = {
        KeyUser: read("userKey"),
        KeyGroup: read("groupKey"),
        idGroup: +row.Id,
        Limit,
        Page,
      };
      const data = await dispatch(getTemplates(params));
      setTblData(data.list);
      setCurrentPage(data.pagination.Page);
      setSizePerPage(data.pagination.Limit);
      setTotal(data.pagination.Total);
    } catch (err) {
      console.error("[onGetTemplates]", err);
    }
    setTimeout(() => {
      setLoading(false);
    }, 200);
  };

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      {columns.length !== 0 && (
        <RemoteTable
          data={tblData}
          keyField="num"
          columns={columns}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
        />
      )}
    </Fragment>
  );
}
